import * as React from "react";

export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { error: null, errorInfo: null };
    }

    componentDidCatch(error, errorInfo) {
        // Catch errors in any components below and re-render with error message
        this.setState({
            error: error,
            errorInfo: errorInfo
        })
    }

    render() {
        if (this.state.errorInfo) {
            navigator.serviceWorker.getRegistrations().then((registrations) => {
                registrations.forEach((registration) => {
                    registration.unregister();
                });
            });
            caches.keys().then((keyList) => {
                return Promise.all(
                    keyList.map((key) => {
                        return caches.delete(key);
                    })
                );
            });

            setTimeout(() => {
                window.location.reload();
            }, 5000)
            // Error path
            return (
                <div>
                    <h2>Something went wrong.</h2>
                    <h4>
                        {this.state.error && this.state.error.toString()}
                    </h4>
                    <h4>
                        Please wait while we try to recover
                    </h4>
                </div>
            )
        }
        // Normally, just render children
        return this.props.children;
    }
}
//<details style={{ whiteSpace: 'pre-wrap' }}>
//                        {this.state.errorInfo.componentStack}
//                    </details>

